<ng-form class="block"
  #stepForm="ngForm">

  @if (shouldShowList) {
    @if (shouldShowToShipping) {
      <div
        class="m-t-2">
        <input-wrap class="m-t-3 block">
        <checkbox name="to_shipping"
          (change)="detectChanges()"
          [(ngModel)]="checkoutFormComponent.data.billing.to_shipping">
          {{'Same as delivery address' | translate}}
        </checkbox>
      </input-wrap>
    </div>
  }
  @if (shouldShowNotToShippingPart) {
    <radio-group [name]="isBilling ? 'customer_address_id_billing' : 'customer_address_id'"
      [value]="data.customer_address_id"
      [(ngModel)]="data.customer_address_id">
      @if (shouldShowAddressBook) {
        <div class="flex flex-wrap delivery-options"
          >
          <h6 class="p1 m-t-9 m-b-1">{{'Your saved addresses' | translate}}</h6>
          @for (item of addressBook.addresses; track item) {
            <radio class="w-12 block m-t-5 p-l-1"
              [top]="true"
              (click)="applyAddress(item)"
              [value]="item.id">
              {{ item.data.nickname }}
              <address-short [address]="item.data"></address-short>
            </radio>
          }
        </div>
      }
      @if (shouldShowAddNew) {
        <radio class="block m-t-5 p-l-1"
          (click)="applyAddress()"
          [value]="0">
          {{ 'Add new address'| translate }}
        </radio>
      }
    </radio-group>
  }
}

@if (shouldShowForm) {
  @if (!isBilling) {
    <p
      class="p2 m-t-9">
      {{'Delivery address' | translate}}
    </p>
  }
  <address-fieldset class="block"
    [ngClass]="{'m-t-5' : checkoutStepComponent.name === 'delivery'}"
    [type]="isBilling ? 'billing' : 'shipping'"
    [stepName]="checkoutStepComponent.name"
    [submitSubject]="checkoutStepComponent.submittedSubject"
    (saveAddress)="save()"
    [form]="stepForm"
    [data]="data">
  </address-fieldset>
}

@if (shouldShowNotToShippingPart && !shouldShowForm) {
  <input-wrap>
  <input type="hidden"
    [(ngModel)]="data.customer_address_id"
    name="customerAddressId"
    required>
</input-wrap>
}
</ng-form>
